module.exports = __webpack_public_path__ + "img/56.8.TSS.52d73471.png";